import { j as e, c as o } from "./utils-BdNIfrGQ.js";
import { a as m } from "./Button-CzIiGCVn.js";
import { c as h } from "./index-Di82Y7n3.js";
import { D as c } from "./Div-spVpsZsH.js";
import "./Div.skeleton-DLnqOZrU.js";
import { F as _ } from "./Flex-BA9xHq_p.js";
import "./Grid-DJGISvmf.js";
import * as l from "react";
import { P as z } from "./index-oiSd2zY3.js";
import { X as H } from "./x-BXShoIAM.js";
import { O as x, P, C as p, T as u, D as w, R as E, b as O, a as L } from "./index-DMKTT9GV.js";
const k = E, A = O, j = L, B = P, g = l.forwardRef(({ className: t, ...a }, s) => /* @__PURE__ */ e.jsx(
  x,
  {
    className: o(
      "fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      t
    ),
    ...a,
    ref: s
  }
));
g.displayName = x.displayName;
const I = h(
  "overflow-y-scroll fixed z-50 bg-white text-foreground shadow-lg transition ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-500",
  {
    variants: {
      side: {
        top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
        bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
        left: "inset-y-0 left-0 h-full border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left",
        right: "inset-y-0 right-0 h-full data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }
), N = l.forwardRef(({ side: t = "right", className: a, children: s, ...i }, r) => /* @__PURE__ */ e.jsx(B, { children: /* @__PURE__ */ e.jsx(g, { children: /* @__PURE__ */ e.jsx(
  p,
  {
    ref: r,
    className: o(I({ side: t }), a, "flex flex-col h-full"),
    ...i,
    children: s
  }
) }) }));
N.displayName = p.displayName;
const y = ({
  className: t,
  ...a
}) => /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx("div", { className: o("flex p-6 shadow", t), ...a }) });
y.displayName = "SheetHeader";
const S = ({
  className: t,
  ...a
}) => /* @__PURE__ */ e.jsx("div", { className: o("flex", t), ...a });
S.displayName = "SheetFooter";
const n = l.forwardRef(({ className: t, ...a }, s) => /* @__PURE__ */ e.jsx(u, { ref: s, className: o("text-foreground", t), ...a }));
n.displayName = u.displayName;
const b = l.forwardRef(({ className: t, ...a }, s) => /* @__PURE__ */ e.jsx(
  w,
  {
    ref: s,
    className: o("text-sm text-muted-foreground", t),
    ...a
  }
));
b.displayName = w.displayName;
const f = h("", {
  variants: {
    width: {
      navigation: "w-[304px]",
      sm: "w-full max-w-sm",
      "1/4": "w-full sm:w-1/4",
      md: "w-full max-w-md",
      "1/2": "w-full sm:w-1/2",
      lg: "w-full max-w-lg",
      "3/4": "w-full sm:w-3/4",
      xl: "w-full max-w-xl",
      full: "w-full"
    }
  },
  defaultVariants: {
    width: "navigation"
  }
});
var T = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), W = "VisuallyHidden", v = l.forwardRef(
  (t, a) => /* @__PURE__ */ e.jsx(
    z.span,
    {
      ...t,
      ref: a,
      style: { ...T, ...t.style }
    }
  )
);
v.displayName = W;
const Q = ({
  trigger: t,
  width: a,
  sheetTitle: s,
  sheetTitleVisible: i = !0,
  description: r,
  headerContent: C,
  children: R,
  fixedFooter: d,
  sheetContentProps: D,
  ...V
}) => /* @__PURE__ */ e.jsxs(k, { ...V, children: [
  /* @__PURE__ */ e.jsx(A, { asChild: !0, children: /* @__PURE__ */ e.jsx(m, { ...t }) }),
  /* @__PURE__ */ e.jsxs(N, { className: o(f({ width: a }), "inherit"), ...D, children: [
    s && i && /* @__PURE__ */ e.jsxs(y, { className: o("flex-col pt-6 px-7 gap-y-5"), "data-testid": "sheet-header", children: [
      /* @__PURE__ */ e.jsxs(n, { className: "flex justify-between items-center", children: [
        /* @__PURE__ */ e.jsxs(_, { className: "inline-flex items-center", gap: "3", children: [
          s.icon,
          s.text
        ] }),
        /* @__PURE__ */ e.jsx(j, { asChild: !0, children: /* @__PURE__ */ e.jsx(m, { variant: "ghost", "aria-label": "Close", size: "icon", children: /* @__PURE__ */ e.jsx(H, { size: 16, strokeWidth: 2, className: "mx-auto" }) }) })
      ] }),
      r && /* @__PURE__ */ e.jsx(b, { children: r }),
      C
    ] }),
    !i && /* @__PURE__ */ e.jsx(v, { asChild: !0, children: /* @__PURE__ */ e.jsx(n, { children: s.text }) }),
    R,
    d && /* @__PURE__ */ e.jsx(c, { className: d.footerBuffer, children: /* @__PURE__ */ e.jsx(
      c,
      {
        className: o(
          "fixed bottom-0 p-5 bg-white w-full shadow-[0_-2px_8px_0_hsla(0,0%,10%,0.08)]",
          f({ width: a })
        ),
        "data-testid": "sheet-fixed-footer",
        children: /* @__PURE__ */ e.jsx(S, { className: o(d.footerClasses), children: d.footerContent })
      }
    ) })
  ] })
] }), Z = (t) => /* @__PURE__ */ e.jsx(j, { asChild: !0, ...t });
export {
  Q as S,
  Z as a
};
